import React from 'react';

import UserActivityListContainer from '@src/components/administration/UserActivityListContainer';

const UserActivityListPage = () => <UserActivityListContainer />;

export default UserActivityListPage;
